export const adminRoleKeys = ['admin', 'support']

export const masterAdminRoleKeys = ['admin']

export const agencyAdminRoleKeys = ['office_administrator', 'office_director']

export const agentRoleKeys = ['agent', 'personal_assistant']

export const agencyRoleKeys = agencyAdminRoleKeys.concat(agentRoleKeys)

export const brandRoleKeys = ['brand_administrator']

export const providerRoleKeys = ['provider_director', 'provider_employee', 'provider_contractor']

export const providerDirectorRoles = ['provider_director']
